import { Component, OnInit } from '@angular/core';
import { SolicitudIntermediarioService } from '../../Service/solicitudIntermediario.service';
import { NeoIntermediarioFinancieroService } from '../../Service/neoIntermediarioFinanciero.service';
import { NeoTiposNegacionService } from '../../../comun/services/neoTiposNegacion.service';
import { Departamento } from '../../../comun/models/departamento';
import { Ciudad } from '../../../comun/models/ciudad';
import { NeoTipoNegacion } from '../../../comun/models/neoTipoNegacion';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DataLocalStorageService } from '../../Service/dataLocalStorage.service';
import { AlertService } from '../../../services/alert.service';
import { ParametrosService } from 'src/app/services/parametros.service';
import { UserService } from 'src/app/services/user.service';
import { CurrencyPipe } from '@angular/common';
import { NeoCalcularCuota } from '../../Model/neoCalcularCuota';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';
import { NeoTrazabilidadAuditoriaDTO } from '../../Model/neoTrazabilidadAuditoriaDTO';
import { TrazabilidadAuditoriaService } from '../../Service/trazabilidad-auditoria.service';
import { Constantes } from 'src/app/comun/data/constantes';
declare var $: any;

const aprobarSolicitud = {
  idSolicitud: '',
  observacion: '',
  idUsuario: null,
  idCliente: null,
  valorDesembolsado: 0,
  tasaFinal: null,
  plazoFinal: null,
  cuotaFinal: null,
  datosLineaIntermediarioForm: 0,
  tipoRecurso: null,
  garantia: null
};

const aprobarSolicitudBx = {
  idSolicitud: null,
  idUsuario: null,
  idCliente: null,
  aplicaFNG: null,
  margenFNG: null,
  numeroReferenciaPagareIF: null,
  descripcionGarantia: null,
  plazoFinal: null,
  valorDesembolsado: 0
};

const PATRON_VALOR_TASA = '^[0-9]{1,3}(.[0-9]{1,3})?$';
const TASA_MINIMA = 0.001;
const TASA_MAXIMA = 1000;

const negarSolicitud = {
  idSolicitud: '',
  observaciones: '',
  idUsuario: null,
  idCliente: null,
  idTipoNegacionDesembolso: null,
};

@Component({
    selector: 'app-confirmar-desembolso-solicitud-microempresario',
    templateUrl: './confirmar-desembolso-solicitud-microempresario.component.html',
    styleUrls: [
        './confirmar-desembolso-solicitud-microempresario.component.scss',
    ],
    providers: [
        SolicitudIntermediarioService,
        ParametrosService,
        NeoIntermediarioFinancieroService,
        NeoTiposNegacionService,
    ],
    standalone: false
})

export class ConfirmarDesembolsoSolicitudMicroempresarioComponent
  implements OnInit {
  public departamentos: Departamento[] = [];
  public ciudades: Ciudad[] = [];
  public solicitudesPendientes: any[] = [];
  public tiposNegacion: NeoTipoNegacion[] = [];
  public user;
  public neoCalcularCuota: NeoCalcularCuota;
  public valor = { valorSolicitudAprobar: 0 };
  public CANTIDAD_MAXIMA_PLAZO_MESES = 120;
  datosLineaIntermediarioForm: Number = null;
  cuotafinal: any;
  periodicidad: null;
  filterForm: UntypedFormGroup;
  confirmarForm: UntypedFormGroup;
  confirmarBxForm: UntypedFormGroup;
  estados: any[] = [];
  idSolicitudAprobar: String = '';
  monto: String = '';
  cuota: String = '';
  plazo: String = '';
  tasa: any;
  valorAprobar: Number = 0;
  observacionSolicitudAprobar: String;
  paginaActual: Number = 1;
  totalPaginas: Number = null;
  idSolicitudNegar: String = '';
  idTipoNegacion: Number = null;
  textObservacion: string = '';
  mensajeEnviadaBE: String = "¡La información de esta solicitud ya ha sido enviada a Banca Electrónica y actualmente se encuentra en trámite!";

  idTrazabilidad: number = 0;
  constructor(
    private _solicitudIntermediarioService: SolicitudIntermediarioService,
    private _parametrosService: ParametrosService,
    private router: Router,

    private _neoIntermediarioFinancieroService: NeoIntermediarioFinancieroService,
    private _userIntermediarioService: UserService,
    private _neoTiposNegacionService: NeoTiposNegacionService,
    private _dataLocalStorageService: DataLocalStorageService,
    private formBuilder: UntypedFormBuilder,
    private alertService: AlertService,
    public pipe: CurrencyPipe,
    private _sweetAlert: SweetAlertService,
    private readonly _serviceTrazabilidad: TrazabilidadAuditoriaService
  ) {

    window.scroll(0, 0);
    this.user = this._userIntermediarioService.getUser();

    this.filterForm = this.formBuilder.group({
      idCiudad: null,
      idDepartamento: null,
      idSolicitud: null,
      fechaRecepcion: null,
      idEstadoSolicitud: null,
      idCliente: this.user.idCliente,
      isFilterDesembolso: true,
      isFilterRevisar: false,
      isFilterAprobar: false,
      pagina: this.paginaActual,
      idUsuario: this.user.idUsuario
    });

    this.confirmarForm = this.formBuilder.group({
      desembolso: ['', Validators.required],
      valorTasa: ['', Validators.required],
      plazo: ['', Validators.required],
      tipoRecurso: ['', Validators.required],
      garantia: ['', Validators.required],
      observacion: ['', Validators.required],
    });

    this.confirmarBxForm = this.formBuilder.group({
      aplicaFNG: [null, Validators.required],
      margenFNG: [null],
      numeroReferenciaPagareIF: [null, Validators.required],
      descripcionGarantia: [null]
    });

  }

  ngOnInit(): void {
    this.neoCalcularCuota = new NeoCalcularCuota(
      null,
      null,
      null,
      null
    );
    this.setPipeForm();
    this.getSolicitudes();
    this._solicitudIntermediarioService.getEstadosIntermediario(this.user.idUsuario).subscribe(
      (response) => {
        this.estados = response.estados;
      },
      (error) => {
        this._sweetAlert.errorModal("Error!", true, 'No fue posible cargar los datos');
      },
      () => {
        setTimeout(() => {
          $('.selectpicker').selectpicker('refresh');
        });
      }
    );

    this._parametrosService.getDepartamentos('169').subscribe(
      (response) => {
        this.departamentos = response['data'];
      },
      (error) => {
        this._sweetAlert.errorModal("Error!", true, 'No fue posible cargar los departamentos');
      }
    );
  }

  getSolicitudes() {
    this._neoIntermediarioFinancieroService
      .getFiltrarSolicitud(this.filterForm.value)
      .subscribe((data: any) => {
        this.solicitudesPendientes = data.data;
        this.totalPaginas = data.paginasTotales;
      });
  }

  changePage(i) {
    this.paginaActual = i;
    this.getSolicitudes();
  }

  getCiudades(idDepartamento) {
    if (idDepartamento != 'null') {
      this._parametrosService.getCiudades(idDepartamento).subscribe(
        (response) => {
          this.ciudades = response['data'];
        },
        (error) => {
          this._sweetAlert.errorModal("Error!", true, 'No fue posible cargar las ciudades');
        }
      );
    } else {
      this.ciudades = [];
    }
  }

  verDetalleSolicitud(i) {
    var numeroSolicitud = this.solicitudesPendientes[i].numeroSolicitud;
    this._dataLocalStorageService.saveIdSolicitudPendHome(numeroSolicitud);
    this.router.navigate(
      [
        '/solicitud/intermediario/' + numeroSolicitud,
      ],
      { state: { from: Constantes.TRANSACCIONAL } });
  }

  aprobar(i) {
    this.aprobacionDesembolso(String(this.solicitudesPendientes[i].numeroSolicitud));
    this.confirmarForm.reset();
    this.confirmarForm.get('observacion').setValue('');
    aprobarSolicitud.idUsuario = Number(this.user.idUsuario);
    aprobarSolicitud.idCliente = Number(this.user.idCliente);
    this.idSolicitudAprobar = this.solicitudesPendientes[i].numeroSolicitud;
    this.confirmarForm.get('desembolso').setValue(this.solicitudesPendientes[i].monto);
    this.confirmarForm.get('valorTasa').setValue(this.solicitudesPendientes[i].tasa);
    this.confirmarForm.get('plazo').setValue(this.solicitudesPendientes[i].plazo);
    this.cuota = this.solicitudesPendientes[i].cuota;
    this.periodicidad = this.solicitudesPendientes[i].periodicidad;
    aprobarSolicitud.idSolicitud = String(this.idSolicitudAprobar);
    $('#aceptarModal').modal('show');
  }

  confirmarAprobacionSolicitud() {
    if (this.confirmarForm.valid) {
      $('#confirmarDesembolso').modal('show');
    } else {
      this.confirmarForm.markAllAsTouched();
    }
  }

  async confirmarDesembolso() {
    $('#aceptarModal').modal('hide');
    aprobarSolicitud.valorDesembolsado = Number(this.confirmarForm.get('desembolso').value.replaceAll(',', ''));
    aprobarSolicitud.plazoFinal = Number(this.confirmarForm.get('plazo').value);
    aprobarSolicitud.tasaFinal = Number(this.confirmarForm.get('valorTasa').value);
    await this.calcularCuota();
    aprobarSolicitud.cuotaFinal = Number(this.cuotafinal).toFixed(2);
    aprobarSolicitud.tipoRecurso = this.confirmarForm.get('tipoRecurso').value;
    aprobarSolicitud.garantia = this.confirmarForm.get('garantia').value;
    aprobarSolicitud.observacion = this.confirmarForm.get('observacion').value;
    this._neoIntermediarioFinancieroService
      .confirmarDesembolso(aprobarSolicitud)
      .subscribe(
        (response) => {
          if (response['exitoso'] == true) {
            this.cerrarTrazabilidad(this.idTrazabilidad);
            this.getSolicitudes();
            this._sweetAlert.successModal(response['mensaje']);
            this.limpiarFiltroConf();
            $('#aceptarModal').modal('hide');
          } else {
            this._sweetAlert.errorModal("Error!", true, 'No fue posible confirmar el desembolso');
          }
        },
        (error) => {
          this._sweetAlert.errorModal("Error!", true, 'No fue posible confirmar el desembolso');
        }
      );
  }

  limpiarFiltroConf() {
    aprobarSolicitud.idCliente = null;
    aprobarSolicitud.idSolicitud = '';
    aprobarSolicitud.idUsuario = null;
    aprobarSolicitud.valorDesembolsado = null;
    aprobarSolicitud.plazoFinal = null;
    aprobarSolicitud.tasaFinal = null;
    aprobarSolicitud.cuotaFinal = null;
    aprobarSolicitud.observacion = '';
    this.confirmarForm.get('desembolso').setValue(null);
    this.confirmarForm.get('plazo').setValue(null);
    this.confirmarForm.get('valorTasa').setValue(null);
    this.confirmarForm.get('observacion').setValue(null);
    this.confirmarForm.get('garantia').setValue(null);
    this.confirmarForm.get('tipoRecurso').setValue(null);
    this.cuotafinal = 0;
    this.paginaActual = 1;
  }

  async calcularCuota() {
    if (
      aprobarSolicitud.valorDesembolsado != null &&
      aprobarSolicitud.valorDesembolsado !== 0 &&
      aprobarSolicitud.plazoFinal !== 0 &&
      aprobarSolicitud.tasaFinal !== 0 &&
      this.periodicidad !== 0
    ) {
      this.neoCalcularCuota.monto = aprobarSolicitud.valorDesembolsado;
      this.neoCalcularCuota.plazo = Number(aprobarSolicitud.plazoFinal);
      this.neoCalcularCuota.tasafinalEA = Number(aprobarSolicitud.tasaFinal);
      this.neoCalcularCuota.periodicidad = Number(this.periodicidad);
      let answer = await this._neoIntermediarioFinancieroService
        .coutaRecursosPropios(this.neoCalcularCuota).toPromise();
      if (answer['exitoso'] == true) {
        this.cuotafinal = answer['cuotaAproximada'];
      } else {
        this._sweetAlert.errorModal("Error!", true,
          'error'
        );
      }
    }
  }

  negarSolicitud(i) {
    this.idSolicitudNegar = this.solicitudesPendientes[i].numeroSolicitud;
    negarSolicitud.idSolicitud = String(this.idSolicitudNegar);
    negarSolicitud.idCliente = Number(this.user.idCliente);
    negarSolicitud.idUsuario = Number(this.user.idUsuario);
    $('#negarModal').modal('show');
    this.negacionDesembolso(String(this.idSolicitudNegar));
    this._parametrosService.getTiposNegacionDesembolso().subscribe(
      (response: any) => {
        this.tiposNegacion = response;
      },
      (error) => {
        this._sweetAlert.errorModal("Error!", true,
          'No fue posible cargar los motivos de negación'
        );
      },
      () => {
        setTimeout(() => {
          $('.selectpicker').selectpicker('refresh');
          this.idTipoNegacion = null;
          this.textObservacion = '';
        });
      }
    );
  }

  confirmarNegacionSolicitud() {
    if (this.idTipoNegacion != null && this.textObservacion.length != 0) {
      if (negarSolicitud.idCliente && negarSolicitud.idSolicitud) {
        negarSolicitud.observaciones = this.textObservacion;
        negarSolicitud.idTipoNegacionDesembolso = Number(this.idTipoNegacion);
        this._neoIntermediarioFinancieroService
          .negarDesembolso(negarSolicitud)
          .subscribe(
            (response) => {
              if (response['exitoso'] == true) {
                this.getSolicitudes();
                this._sweetAlert.successModal('Negación de desembolso realizada correctamente.');
                negarSolicitud.idCliente = null;
                negarSolicitud.observaciones = '';
                negarSolicitud.idSolicitud = '';
                negarSolicitud.idUsuario = null;
                negarSolicitud.idTipoNegacionDesembolso = '';
                this.cerrarTrazabilidad(this.idTrazabilidad);
                $('#negarModal').modal('hide');
              } else {
                this._sweetAlert.errorModal("Error!", true, 'No fue posible negar el desembolso.');
              }
            },
            (error) => {
              this._sweetAlert.errorModal("Error!", true,
                'No fue posible negar el desembolso.' + this.idSolicitudNegar
              );
            }
          );
      } else {
        this._sweetAlert.errorModal("Error!", true,
          'No fue posible cargar los datos para la negación'
        );
      }
    } else {
      if (this.idTipoNegacion == null) {
        this._sweetAlert.errorModal("Error!", true, 'Seleccione el motivo de negación');
      } else {
        this._sweetAlert.errorModal("Error!", true, 'Describa la observacion de la negación');
      }
    }
  }

  limpiarFiltro() {
    this.filterForm.get('idCiudad').setValue(null);
    this.filterForm.get('idDepartamento').setValue(null);
    this.filterForm.get('idSolicitud').setValue(null);
    this.filterForm.get('fechaRecepcion').setValue(null);
    this.filterForm.get('idEstadoSolicitud').setValue(null);
    this.filterForm.get('pagina').setValue(1);
    this.paginaActual = 1;
    this.getSolicitudes();
  }

  setPipeForm() {
    this.confirmarForm.controls['desembolso'].valueChanges.subscribe(
      (data) => {
        if (data !== null) {
          this.confirmarForm.patchValue(
            {
              desembolso: this.pipe.transform(
                data.toString().replace(/\D/g, '').replace(/^0+/, ''),
                '',
                '',
                '1.0-0'
              ),
            },
            { emitEvent: false }
          );
        }
      }
    );
  }

  validateField(key: string) {
    return (
      (this.confirmarForm.get(key).dirty ||
        this.confirmarForm.get(key)?.touched) &&
      this.confirmarForm.get(key)?.invalid
    );
  }


  validarTasa() {
    if (this.confirmarForm.get('valorTasa').value != null) {
      this.setearValidadoresLineaInterediarioForm('valorTasa', [
        Validators.required,
        Validators.min(TASA_MINIMA),
        Validators.max(TASA_MAXIMA),
        Validators.pattern(PATRON_VALOR_TASA),
      ]);
    } else {
      this.setearValidadoresLineaInterediarioForm('valorTasa', null);
    }
  }

  setearValidadoresLineaInterediarioForm(
    nombreCampo: string,
    validadores: any
  ) {
    this.confirmarForm.controls[nombreCampo].setValidators(
      validadores
    );
    this.confirmarForm.controls[
      nombreCampo
    ].updateValueAndValidity();
  }

  validateNumber(event: any) {
    const pattern = /[0-9.]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  aprobarDesembolsoBx(i) {
    this.aprobacionDesembolso(String(this.solicitudesPendientes[i].numeroSolicitud));
    this.confirmarBxForm.reset();
    aprobarSolicitudBx.idUsuario = Number(this.user.idUsuario);
    aprobarSolicitudBx.idCliente = Number(this.user.idCliente);
    this.idSolicitudAprobar = this.solicitudesPendientes[i].numeroSolicitud;
    aprobarSolicitudBx.idSolicitud = String(this.solicitudesPendientes[i].numeroSolicitud);
    aprobarSolicitudBx.valorDesembolsado = Number(this.solicitudesPendientes[i].monto);
    aprobarSolicitudBx.plazoFinal = Number(this.solicitudesPendientes[i].plazo);
    $('#confirmarDesembolsoBX').modal('show');
  }

  validarGarantia(x: boolean) {
    if (x === true) {
      this.setearValidadoresForm('margenFNG', [
        Validators.required,
      ]);
      this.setearValidadoresForm('descripcionGarantia', [
        Validators.required, Validators.pattern('^[A-Za-zÁÉÍÓÚáéíóúÑñ0-9 ]{20,300}$')
      ]);
    } else {
      this.setearValidadoresForm('margenFNG', null);
      this.setearValidadoresForm('descripcionGarantia', null);
      this.confirmarBxForm.get('descripcionGarantia').setValue(null);
      this.confirmarBxForm.get('margenFNG').setValue(null);
    }
  }

  validateFieldBx(key: string) {
    return (
      (this.confirmarBxForm.get(key).dirty ||
        this.confirmarBxForm.get(key)?.touched) &&
      this.confirmarBxForm.get(key)?.invalid
    );
  }

  setearValidadoresForm(
    nombreCampo: string,
    validadores: any
  ) {
    this.confirmarBxForm.controls[nombreCampo].setValidators(
      validadores
    );
    this.confirmarBxForm.controls[
      nombreCampo
    ].updateValueAndValidity();
  }

  confirmarDesembolsoRecursosBancoldex() {
    $('#confirmarDesembolsoBX').modal('hide');
    aprobarSolicitudBx.aplicaFNG = this.confirmarBxForm.get('aplicaFNG').value;
    aprobarSolicitudBx.margenFNG = this.confirmarBxForm.get('margenFNG').value;
    aprobarSolicitudBx.descripcionGarantia = this.confirmarBxForm.get('descripcionGarantia').value;
    aprobarSolicitudBx.numeroReferenciaPagareIF = this.confirmarBxForm.get('numeroReferenciaPagareIF').value;
    this._neoIntermediarioFinancieroService
      .confirmarDesembolsoBx(aprobarSolicitudBx)
      .subscribe(
        (response) => {
          if (response['exitoso'] == true) {
            this.getSolicitudes();
            this._sweetAlert.successModal(response['mensaje']);
            this.confirmarBxForm.reset();
            aprobarSolicitudBx.idSolicitud = null;
            aprobarSolicitudBx.idUsuario = null;
            aprobarSolicitudBx.idCliente = null;
            aprobarSolicitudBx.aplicaFNG = null;
            aprobarSolicitudBx.margenFNG = null;
            aprobarSolicitudBx.numeroReferenciaPagareIF = null;
            aprobarSolicitudBx.descripcionGarantia = null;
            aprobarSolicitudBx.valorDesembolsado = 0;
            this.cerrarTrazabilidad(this.idTrazabilidad);
            $('#aceptarModal').modal('hide');
          } else {
            this._sweetAlert.errorModal("Error!", true, response['mensaje']);
          }
        },
        (error) => {
          this._sweetAlert.errorModal("Error!", true, 'Error al crear solicitud en Banca Electrónica.');
        }
      );
  }

  aprobacionDesembolso(idSolicitud: string) {
    const body: NeoTrazabilidadAuditoriaDTO = {
      nombreSeccion: Constantes.TRANSACCIONAL,
      nombrePantalla: Constantes.CONFIRMAR_DESEMBOLSO,
      idCliente: +this.user.idCliente,
      idUsuario: +this.user.idUsuario,
      idSolicitud: String(idSolicitud),
      perfil: Constantes.PERFIL_ALIADO
    }
    this._serviceTrazabilidad.generarAprobacionDesembolso(body).subscribe(
      {
        next: resp => {
          this.idTrazabilidad = resp.trazabilidad.idTrazabilidad;
        },
        error: err => {
        }
      });
  }

  negacionDesembolso(idSolicitud: string) {
    const body: NeoTrazabilidadAuditoriaDTO = {
      nombreSeccion: Constantes.TRANSACCIONAL,
      nombrePantalla: Constantes.NEGAR_DESEMBOLSO,
      idCliente: +this.user.idCliente,
      idUsuario: +this.user.idUsuario,
      idSolicitud: String(idSolicitud),
      perfil: Constantes.PERFIL_ALIADO
    }
    this._serviceTrazabilidad.generarNegacionDesembolso(body).subscribe(
      {
        next: resp => {
          this.idTrazabilidad = resp.trazabilidad.idTrazabilidad;
        },
        error: err => {
        }
      });
  }

  cancelar() {
    this.cerrarTrazabilidad(this.idTrazabilidad);
  }


  cerrarTrazabilidad(idTrazabilidad: number) {
    this._serviceTrazabilidad.cierreTrazabilidad(idTrazabilidad).subscribe({
      next: resp => {
      },
      error: err => {
      }
    });
  }

}
